import dayjs, { Dayjs } from "dayjs";
import { PerformancePeriod } from "../../../../../features/optifundDashboardSlice";

// start_date/end_date are required by every Performance query (see spec
// Section 2) - these give each period a sensible default window so a
// request is never sent without them, matching the Account Summary
// labels ("Last 30 Days" / "Last 6 Weeks" / "Last 12 Months").
export function getDefaultPerformanceDateRange(period: PerformancePeriod): [Dayjs, Dayjs] {
  const end = dayjs();
  switch (period) {
    case "weekly":
      return [end.subtract(6, "week"), end];
    case "monthly":
      return [end.subtract(12, "month"), end];
    case "daily":
    default:
      return [end.subtract(30, "day"), end];
  }
}

// Resolves the effective [start, end] to send/display for a period: the
// user's manual selection if they made one, otherwise the period's default.
export function resolvePerformanceDateRange(
  period: PerformancePeriod,
  storedRange: [Dayjs | null, Dayjs | null]
): [Dayjs, Dayjs] {
  const [storedStart, storedEnd] = storedRange;
  if (storedStart && storedEnd) {
    return [storedStart, storedEnd];
  }
  return getDefaultPerformanceDateRange(period);
}
